<ng-container>
	<img src="../../../assets/img/{{themeService.theme}}/how-works.svg" alt="How it works" width="150px">
	<h2>About delegates</h2>
	<p>Your delegates are the people closest to you in life – your family, friends or trusted advisors – that you choose to share your plan with.</p>
	<p>You can share what you wish, when you wish. So, whether it's for help with planning and day-to-day organisation or to ease estate administration for when the inevitable happens - adding delegates to your plan ensures they can access the information they’ll need, when they need it most.</p>
	<p>For each delegate, you can select which access permission to apply to each section of your plan. You can change or remove these permissions at anytime, meaning you’re in complete control over how and when you share your plan with your delegate.</p>
	<!-- <section class="explanations">
		<div class="rights">
			<div class="div-opacity div-opacity-contributor"></div>
			<i class="fa fas fa-pen-alt contributor-fa"></i>
			<div class="contributor rights-div">Contributor</div>
		</div>
		<p>Allow your delegate to view and edit all items stored in this section of your plan, so that they can help you to build and manage your plan.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-now"></div>
			<i class="fa fas fa-eye viewer-now-fa"></i>
			<div class="viewer-now rights-div">Viewer - Now</div>
		</div>
		<p>Allow your delegate to view all items stored in this section of your plan but prevent them from making any changes themselves.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-future"></div>
			<i class="fa fas fa-eye viewer-future-fa"></i>
			<div class="viewer-future rights-div">Viewer - Future</div>
		</div>
		<p>Allow your delegate to view all items stored in this section if you pass away or lose mental capacity.</p>
		<p>Should this happen, they must request access from us by providing either a death or medical certificate. <br> You can learn more about our plan unlock process <a class="go-to-request" [routerLink]="['/request-access']">here</a>.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-no-access"></div>
			<i class="fa fas fa-lock no-access-fa"></i>
			<div class="no-access rights-div">No Access</div>
		</div>
		<p>Prevent your delegate from accessing all items in this section of your plan, at all times.</p>
	</section> -->
</ng-container>
